<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card m-b-30">
                <div class="card-body">

                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card m-b-30">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12 text-right">
                                            <button type="submit" name="find" class="btn btn-info btn-dark"
                                                (click)="gotoaddcat();">
                                                <i class="fa fa-list"></i>&nbsp;&nbsp;ADD CATEGORY
                                            </button>&nbsp;&nbsp;
                                            <button type="button" name="find" class="btn btn-info btn-dark"
                                                (click)="gotoaddsubcat();">
                                                <i class="fa fa-sitemap"></i>&nbsp;&nbsp;ADD SUB
                                                CATEGORY</button>
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <form [formGroup]="createmedicineform">
                                        <!-- <form #appointmentForm="ngForm" name="appointmentForm"> -->
                                        <div class="row">
                                            <div class="col-12">
                                                <h6 class="text-center">ADD MEDICINE</h6>
                                            </div>
                                        </div>

                                        <br /><br />

                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                <div class="text-dark">Select Category</div>
                                                <select class="form-control select"
                                                    (change)="retriveSubcategory($event)" formControlName="med_cate_id">
                                                    <option *ngFor="let x of cate" [value]="x.med_cate_id">
                                                        {{ x.med_cate}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                        </div>

                                        <br /><br />
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                <div class="text-dark">Select Sub-Category</div>
                                                <select class="form-control select" formControlName="med_sub_cate_id">
                                                    <option *ngFor="let x of subcate" [value]="x.med_sub_cate_id">
                                                        {{ x.med_sub_cate}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                        </div>

                                        <br /><br />
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                <div class="text-dark">Medicine Name:</div>
                                                <input type="text" formControlName="med_name"
                                                    placeholder="Medicine Name" class="form-control select" />
                                            </div>
                                            <div *ngIf="createmedicineform.get('med_name').hasError('required')"
                                                class="invalid-feedback ml-1">
                                                Medicine Name is <strong>required</strong>.
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                        </div>
                                        <br /><br />

                                        <div class="row">

                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                <div class="text-dark">Select Medicine Type:</div>
                                                <select class="form-control select" formControlName="med_type">

                                                    <option *ngFor="let x of med_type" [value]="x">
                                                        {{ x }}
                                                    </option>

                                                </select>
                                                <div *ngIf="createmedicineform.get('med_type').hasError('required')"
                                                    class="invalid-feedback ml-1">
                                                    Medicine Type is <strong>required</strong>.
                                                </div>
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>

                                        </div>
                                        <br /><br />





                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                <div class="text-dark">Enter Medicine Strength:</div>
                                                <input type="text" formControlName="med_strength" placeholder="Strength"
                                                    class="form-control select" />
                                            </div>
                                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                        </div>

                                        <br /><br />



                                        <div class="row">
                                            <div class="col-12 text-center">
                                                <button type="submit" (click)="createmedicine()"
                                                    [disabled]="createmedicineform.invalid"
                                                    class="btn btn-primary text-white btn-rounded">SAVE
                                                    MEDICINE</button>&nbsp;&nbsp;
                                                <!-- <button type="button" name="find"
                                                        class="btn btn-secondary text-white btn-rounded">Reset</button> -->
                                            </div>
                                        </div>

                                    </form>







                                    <!-- SEARCH PATIENT ENDS -->
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--end container-->